import * as lib from '../api/integrations.js';
import { fetchLoadable } from '../fetchLoadable.js';
import * as actionTypes from './actionTypes.js';
export const get = (id) => fetchLoadable(actionTypes.FETCH_INTEGRATION, lib.get, { id });
export const getAll = () => fetchLoadable(actionTypes.FETCH_INTEGRATIONS, lib.getAll);
export const getCreditorActivations = (creditorId) => {
    return fetchLoadable(actionTypes.FETCH_CREDITOR_INTEGRATIONS_ACTIVATIONS, lib.getCreditorActivations, { creditorId });
};
export const getActivation = (id) => fetchLoadable(actionTypes.FETCH_INTEGRATION_ACTIVATION, lib.getActivation, {
    id,
});
export const activate = (id, newActivation) => lib.activate(id, newActivation).then((activation) => {
    getCreditorActivations(newActivation.creditorId);
    getActivation(activation.id);
});
export const deactivate = (creditorId, id) => lib.deactivate(id).then(() => {
    getCreditorActivations(creditorId);
    getActivation(id);
});
export const reactivate = (creditorId, id) => lib.reactivate(id).then(() => {
    getActivation(id);
    getCreditorActivations(creditorId);
});
export const getMissingApplications = (creditorId, options) => {
    return fetchLoadable(actionTypes.FETCH_MISSING_APPLICATIONS, lib.getMissingApplications, { creditorId, options });
};
//# sourceMappingURL=actions.js.map